/* eslint-disable default-case, no-param-reassign */
import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import produce from 'immer';
import LocalStorageService from 'services/local-storage-service';
import { actions, GroupsActions } from '.';
import { GroupsState } from './types';

const initialState: GroupsState = {
  documentGroups: LocalStorageService.getGroups() || [],
};

const reducer: Reducer<GroupsState, GroupsActions> = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case getType(actions.updateGroupsStorage): {
        LocalStorageService.updateGroups(action.payload);
        draft.documentGroups = action.payload;
        break;
      }
    }

    return draft as GroupsState;
  });

export default reducer;
